module.exports = __webpack_public_path__ + "static/img/1.b031dcd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/1.png
// module id = 33vC
// module chunks = 0